import React, { useState, useEffect } from 'react';

// Modules
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';

// App
import { isCompanyappUser } from '../../utils/helpers';

// UI components
import { BookOpen, Home, User, MapPin, Database } from 'react-feather';
import { FormControlLabel, IconButton, Typography } from '@mui/material';


export default function RHGSidebar(props) {
  const [activeItem, setActiveItem] = useState("home")

  const user = useSelector((state) => state).authReducer.user;
  const permissions = useSelector((state) => state).permissionsReducer.permissions;
  const currentLocation = useSelector((state => state.locationReducer.currentLocation));
  const creatorMode = useSelector((state) => state.creatorModeReducer.creatorMode);

  useEffect(() => {
    setActiveItem(currentLocation);
  }, [currentLocation]);

  const handleClick = (path) => {
    if (props.isMobile) {
      props.sidebarVisibility();
    }

    if (path) {
      setActiveItem(path);
    }
  };

  let showNavigation = "collapsed";
  if (props.showNavigation === true || props.showNavigation === 'true') {
    showNavigation = "expanded";
  }

  const hasCreate = permissions.access_presentation_creator_mode ? true : false;

  // Creator mode is a global flag now, so the nav link points at the one
  // presentations route and lets it resolve the mode. Linking straight to
  // "-creator" would switch edit mode back on after the user turned it off.
  const inCreatorMode = hasCreate && creatorMode;

  return (
    <div className={`navbar-container ${showNavigation} ${inCreatorMode && currentLocation === 'presentations' ? 'presentations-creator' : ''}`}>
      {props.isMobile && (
        <div className="mobile-overlay" onClick={props.sidebarVisibility}></div>
      )}
      <nav className={`navbar ${showNavigation}`}>
        {typeof user.current_user !== 'undefined' ? (
          <>
            <ul>
              

              <li className="nav-item">
                <NavLink
                  to={'presentations'}
                  className="nav-link"
                  onClick={() => handleClick("presentations")}
                >
                  <FormControlLabel
                    variant='nav-item'
                    color={activeItem === 'presentations' ? 'active' : ''}
                    control={
                      <IconButton >
                        <BookOpen size={20} />
                      </IconButton>}
                    label={
                      <Typography variant='span' owner='client'>
                        Presentations
                      </Typography>}
                  />
                </NavLink>
              </li>

              {permissions.access_map === true && (
                <li className="nav-item">
                  <NavLink
                    to={'global-portfolio'}
                    className="nav-link"
                    onClick={() => handleClick("global-portfolio")}
                  >
                    <FormControlLabel
                      variant='nav-item'
                      color={activeItem === 'global-portfolio' ? 'active' : ''}
                      control={
                        <IconButton >
                          <MapPin size={20} />
                        </IconButton>}
                      label={
                        <Typography variant='span' owner='client'>
                          Global Portfolio
                        </Typography>}
                    />
                  </NavLink>
                </li>
              )}

              {isCompanyappUser(user) && (
                <li className="nav-item">
                  <NavLink
                    to={'hotel-profile'}
                    className="nav-link"
                    onClick={() => handleClick("hotel-profile")}
                  >
                    <FormControlLabel
                      variant='nav-item'
                      color={activeItem === 'hotel-profile' ? 'active' : ''}
                      control={
                        <IconButton >
                          <Database size={20} />
                        </IconButton>}
                      label={
                        <Typography variant='span' owner='client'>
                          Hotel Profile
                        </Typography>}
                    />
                  </NavLink>
                </li>
              )}

              {/* {permissions.access_radisson_4u == true && (
                <li className="nav-item">
                  <NavLink
                    to={'radissonforyou'}
                    className={({ isActive, isPending }) => {
                      if (isActive) {
                        setActiveItem("radissonforyou")
                      }
                      return "nav-link"
                    }}
                    onClick={() => handleClick()}
                  >
                    <FormControlLabel
                      variant='nav-item'
                      color={activeItem === 'radissonforyou' ? 'active' : ''}
                      control={
                        <IconButton >
                          <BarChart2 size={20} />
                        </IconButton>}
                      label={
                        <Typography variant='span' owner='client'>
                          Radisson For You
                        </Typography>}
                    />
                  </NavLink>
                </li>
              )} */}
            </ul>
          </>
        ) : (
          <>
            <ul>
              <li className="nav-item">
                <NavLink
                  to="/"
                  className="nav-link"
                  onClick={() => handleClick("home")}
                >
                  <div className="nav-item__icon">
                    <Home size={20} />
                  </div>
                  <span className="nav-item__label">Home</span>
                </NavLink>
              </li>
            </ul>
            <ul>
              <li className="nav-item">
                <NavLink
                  to="/login"
                  className="nav-link"
                  onClick={() => handleClick()}
                >
                  <div className="nav-item__icon">
                    <User size={20} />
                  </div>
                  <span className="nav-item__label">Login</span>
                </NavLink>
              </li>
            </ul>
          </>
        )}
      </nav>
    </div>
  );
}


// const mapStateToProps = (state) => ({
//   user: state.authReducer.user,
//   permissions: state.permissionsReducer.permissions,
// });

// export default connect(mapStateToProps)(Sidebar);

